import React from "react";

const LOGOS = [
  "Hydrotan",
  "C Glancey Double Glazing",
  "FieldOps AI",
  "Front Line Kit Hire",
  "EC Hummers",
  "Highland Tours",
  "Stirling Studio",
  "Glasgow Build Co.",
];

export default function TrustedMarquee() {
  const doubled = [...LOGOS, ...LOGOS];
  return (
    <section className="border-y border-slate-200 bg-slate-50/60 py-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">
          Trusted by ambitious businesses across the UK
        </div>
        <div className="relative">
          <div className="flex marquee-track gap-12 whitespace-nowrap">
            {doubled.map((name, i) => (
              <div
                key={i}
                className="text-slate-400 hover:text-slate-700 transition-colors font-serif text-2xl lg:text-3xl tracking-tight"
                style={{ fontFamily: 'Georgia, "Times New Roman", serif' }}
              >
                {name}
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50/90 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50/90 to-transparent" />
        </div>
      </div>
    </section>
  );
}
